// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/SalesPages/ReceiptModal.module.css */

.ReceiptModal_overlay__Hxddu {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* modal like screenshot: white card, fixed height, scroll inside */
.ReceiptModal_modal__6qn1w {
  width: 320px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  overflow: hidden;

  display: flex;
  flex-direction: column;
  max-height: 92vh;
}

/* ===== top bar ===== */
.ReceiptModal_topBar__N0DdF {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 14px;
  border-bottom: 1px solid #e9e9e9;
  background: #fff;
  flex-shrink: 0;
}

.ReceiptModal_topTitle__\\+vB2\\+ {
  font-size: 16px;
  font-weight: 600;
  color: #111;
}

.ReceiptModal_topClose__ZkO8T {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: transparent;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  color: #444;
}
.ReceiptModal_topClose__ZkO8T:hover {
  background: #f2f2f2;
}

/* ===== scrollable middle area ===== */
.ReceiptModal_scrollArea__YkCau {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f7f7f7;
  padding: 10px 0 14px;
  -webkit-overflow-scrolling: touch;
}

/* language row */
.ReceiptModal_langRow__M4GMb {
  display: flex;
  justify-content: center;
  padding: 6px 0 12px;
}

.ReceiptModal_langSelect__2jjEb {
  width: 320px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  padding: 0 10px;
  outline: none;
  font-size: 14px;
}

/* paper wrapper */
.ReceiptModal_paperWrap__G3zg6 {
  display: flex;
  justify-content: center;
}

.ReceiptModal_paper__heYMW {
  width: 340px;
  background: #fff;
  border-radius: 2px;
  border: 1px solid #e6e6e6;

  padding: 12px 14px;
  font-family: "Courier New", monospace;
  color: #111;
}

/* center header */
.ReceiptModal_centerBlock__kUYEd {
  text-align: center;
  padding-top: 2px;
}

.ReceiptModal_centerTitle__RONlU {
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
}

.ReceiptModal_centerSub__sK9EI {
  margin-top: 6px;
  font-size: 12px;
}

.ReceiptModal_hr__x3r6R {
  margin: 10px 0;
  border-top: 1px solid #111;
}

.ReceiptModal_hrThin__o9lxW {
  margin: 8px 0;
  border-top: 1px solid #888;
}

.ReceiptModal_sectionTitle__LxxUV {
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.ReceiptModal_sectionTitleSmall__Y5baQ {
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

/* two columns like screenshot */
.ReceiptModal_twoCols__eVmyK {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 6px;
}

.ReceiptModal_box__YuwMB {
  border: 1px solid #cfcfcf;
  padding: 8px 8px;
  border-radius: 2px;
}

.ReceiptModal_boxLabel__HylwP {
  font-size: 10px;
  color: #222;
}

.ReceiptModal_boxValue__\\+BrMC {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 700;
}

.ReceiptModal_boxSmall__KyiYm {
  margin-top: 3px;
  font-size: 10px;
  color: #222;
}

/* items */
.ReceiptModal_items__M2XER {
  margin-top: 6px;
}

.ReceiptModal_item__uIW0V {
  padding: 8px 0;
}

.ReceiptModal_itemName__oFrqC {
  font-size: 12px;
  font-weight: 700;
}

.ReceiptModal_itemIndex__NjqJF {
  font-weight: 700;
}

.ReceiptModal_itemNameText__r3wZ7 {
  font-weight: 700;
}

.ReceiptModal_itemRow__iLSoi {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  margin-top: 4px;
}

.ReceiptModal_itemRowMuted__VgrD5 {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  margin-top: 2px;
  color: #333;
}

.ReceiptModal_itemLeft__E7fkX {
  white-space: nowrap;
}

.ReceiptModal_itemRight__XHKvW {
  white-space: nowrap;
}

/* totals */
.ReceiptModal_totals__N3dX0 {
  margin-top: 8px;
}

.ReceiptModal_totalLineMain__DJOpb {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
}

.ReceiptModal_totalLine__Dsi8l {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-size: 12px;
}

.ReceiptModal_totalLabel2__zt98y {
  color: #222;
}

.ReceiptModal_totalValue2__XwhBQ {
  color: #222;
}

/* QR */
.ReceiptModal_qrWrap__DJB25 {
  display: flex;
  justify-content: center;
  margin: 12px 0 8px;
}

.ReceiptModal_address__PV1cm {
  font-size: 11px;
  text-align: left;
}

/* ===== bottom action bar like screenshot ===== */
.ReceiptModal_actionBar__jZZj2 {
  flex-shrink: 0;
  display: flex;
  justify-content: space-around;
  padding: 10px 12px;
  background: #fff;
  border-top: 1px solid #e9e9e9;
}

.ReceiptModal_actionBtn__CSglD {
  width: 64px;
  height: 48px;
  border-radius: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: green;
}
.ReceiptModal_actionBtn__CSglD:hover {
  background: #f2f6ff;
}

/* inputs */
.ReceiptModal_inputContainer__U-oHr {
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  padding: 10px 12px 12px;
  border-top: 1px solid #e9e9e9;
  background: #fff;
}

.ReceiptModal_inputContainer__U-oHr input {
  flex: 1 1;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 10px;
  outline: none;
}

.ReceiptModal_inputContainer__U-oHr button {
  height: 36px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: #111;
  color: #fff;
  cursor: pointer;
}

/* ===== print ===== */
@media print {
  body * {
    visibility: hidden;
  }

  .receipt-print,
  .receipt-print * {
    visibility: visible;
  }

  .receipt-print {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .ReceiptModal_topBar__N0DdF,
  .ReceiptModal_actionBar__jZZj2,
  .ReceiptModal_inputContainer__U-oHr,
  .ReceiptModal_langRow__M4GMb {
    display: none !important;
  }

  .ReceiptModal_scrollArea__YkCau {
    overflow: visible !important;
    background: #fff !important;
    padding: 0 !important;
  }

  .ReceiptModal_paperWrap__G3zg6 {
    padding: 0 !important;
  }

  .ReceiptModal_paper__heYMW {
    border: none !important;
    width: 280px !important;
  }

  @page {
    size: auto;
    margin: 0;
  }
}

/* responsive */
@media (max-width: 560px) {
  .ReceiptModal_modal__6qn1w {
    width: 92vw;
  }
  .ReceiptModal_langSelect__2jjEb {
    width: 80vw;
  }
  .ReceiptModal_paper__heYMW {
    width: 78vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/ReceiptModal.module.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;;EAEzB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,OAAO;AACP;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;AACF;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["/* src/pages/SalesPages/ReceiptModal.module.css */\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* modal like screenshot: white card, fixed height, scroll inside */\n.modal {\n  width: 320px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n  max-height: 92vh;\n}\n\n/* ===== top bar ===== */\n.topBar {\n  height: 46px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 0 14px;\n  border-bottom: 1px solid #e9e9e9;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.topTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111;\n}\n\n.topClose {\n  position: absolute;\n  right: 10px;\n  top: 6px;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  color: #444;\n}\n.topClose:hover {\n  background: #f2f2f2;\n}\n\n/* ===== scrollable middle area ===== */\n.scrollArea {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: #f7f7f7;\n  padding: 10px 0 14px;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* language row */\n.langRow {\n  display: flex;\n  justify-content: center;\n  padding: 6px 0 12px;\n}\n\n.langSelect {\n  width: 320px;\n  height: 36px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  background: #fff;\n  padding: 0 10px;\n  outline: none;\n  font-size: 14px;\n}\n\n/* paper wrapper */\n.paperWrap {\n  display: flex;\n  justify-content: center;\n}\n\n.paper {\n  width: 340px;\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #e6e6e6;\n\n  padding: 12px 14px;\n  font-family: \"Courier New\", monospace;\n  color: #111;\n}\n\n/* center header */\n.centerBlock {\n  text-align: center;\n  padding-top: 2px;\n}\n\n.centerTitle {\n  font-weight: 700;\n  font-size: 13px;\n  text-transform: uppercase;\n}\n\n.centerSub {\n  margin-top: 6px;\n  font-size: 12px;\n}\n\n.hr {\n  margin: 10px 0;\n  border-top: 1px solid #111;\n}\n\n.hrThin {\n  margin: 8px 0;\n  border-top: 1px solid #888;\n}\n\n.sectionTitle {\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.sectionTitleSmall {\n  text-align: center;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n/* two columns like screenshot */\n.twoCols {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 6px;\n}\n\n.box {\n  border: 1px solid #cfcfcf;\n  padding: 8px 8px;\n  border-radius: 2px;\n}\n\n.boxLabel {\n  font-size: 10px;\n  color: #222;\n}\n\n.boxValue {\n  margin-top: 8px;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.boxSmall {\n  margin-top: 3px;\n  font-size: 10px;\n  color: #222;\n}\n\n/* items */\n.items {\n  margin-top: 6px;\n}\n\n.item {\n  padding: 8px 0;\n}\n\n.itemName {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.itemIndex {\n  font-weight: 700;\n}\n\n.itemNameText {\n  font-weight: 700;\n}\n\n.itemRow {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.itemRowMuted {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  margin-top: 2px;\n  color: #333;\n}\n\n.itemLeft {\n  white-space: nowrap;\n}\n\n.itemRight {\n  white-space: nowrap;\n}\n\n/* totals */\n.totals {\n  margin-top: 8px;\n}\n\n.totalLineMain {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.totalLine {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 6px;\n  font-size: 12px;\n}\n\n.totalLabel2 {\n  color: #222;\n}\n\n.totalValue2 {\n  color: #222;\n}\n\n/* QR */\n.qrWrap {\n  display: flex;\n  justify-content: center;\n  margin: 12px 0 8px;\n}\n\n.address {\n  font-size: 11px;\n  text-align: left;\n}\n\n/* ===== bottom action bar like screenshot ===== */\n.actionBar {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: space-around;\n  padding: 10px 12px;\n  background: #fff;\n  border-top: 1px solid #e9e9e9;\n}\n\n.actionBtn {\n  width: 64px;\n  height: 48px;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: green;\n}\n.actionBtn:hover {\n  background: #f2f6ff;\n}\n\n/* inputs */\n.inputContainer {\n  flex-shrink: 0;\n  display: flex;\n  gap: 8px;\n  padding: 10px 12px 12px;\n  border-top: 1px solid #e9e9e9;\n  background: #fff;\n}\n\n.inputContainer input {\n  flex: 1;\n  height: 36px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 0 10px;\n  outline: none;\n}\n\n.inputContainer button {\n  height: 36px;\n  padding: 0 12px;\n  border: none;\n  border-radius: 8px;\n  background: #111;\n  color: #fff;\n  cursor: pointer;\n}\n\n/* ===== print ===== */\n@media print {\n  body * {\n    visibility: hidden;\n  }\n\n  :global(.receipt-print),\n  :global(.receipt-print) * {\n    visibility: visible;\n  }\n\n  :global(.receipt-print) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: auto;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n  }\n\n  .topBar,\n  .actionBar,\n  .inputContainer,\n  .langRow {\n    display: none !important;\n  }\n\n  .scrollArea {\n    overflow: visible !important;\n    background: #fff !important;\n    padding: 0 !important;\n  }\n\n  .paperWrap {\n    padding: 0 !important;\n  }\n\n  .paper {\n    border: none !important;\n    width: 280px !important;\n  }\n\n  @page {\n    size: auto;\n    margin: 0;\n  }\n}\n\n/* responsive */\n@media (max-width: 560px) {\n  .modal {\n    width: 92vw;\n  }\n  .langSelect {\n    width: 80vw;\n  }\n  .paper {\n    width: 78vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ReceiptModal_overlay__Hxddu`,
	"modal": `ReceiptModal_modal__6qn1w`,
	"topBar": `ReceiptModal_topBar__N0DdF`,
	"topTitle": `ReceiptModal_topTitle__+vB2+`,
	"topClose": `ReceiptModal_topClose__ZkO8T`,
	"scrollArea": `ReceiptModal_scrollArea__YkCau`,
	"langRow": `ReceiptModal_langRow__M4GMb`,
	"langSelect": `ReceiptModal_langSelect__2jjEb`,
	"paperWrap": `ReceiptModal_paperWrap__G3zg6`,
	"paper": `ReceiptModal_paper__heYMW`,
	"centerBlock": `ReceiptModal_centerBlock__kUYEd`,
	"centerTitle": `ReceiptModal_centerTitle__RONlU`,
	"centerSub": `ReceiptModal_centerSub__sK9EI`,
	"hr": `ReceiptModal_hr__x3r6R`,
	"hrThin": `ReceiptModal_hrThin__o9lxW`,
	"sectionTitle": `ReceiptModal_sectionTitle__LxxUV`,
	"sectionTitleSmall": `ReceiptModal_sectionTitleSmall__Y5baQ`,
	"twoCols": `ReceiptModal_twoCols__eVmyK`,
	"box": `ReceiptModal_box__YuwMB`,
	"boxLabel": `ReceiptModal_boxLabel__HylwP`,
	"boxValue": `ReceiptModal_boxValue__+BrMC`,
	"boxSmall": `ReceiptModal_boxSmall__KyiYm`,
	"items": `ReceiptModal_items__M2XER`,
	"item": `ReceiptModal_item__uIW0V`,
	"itemName": `ReceiptModal_itemName__oFrqC`,
	"itemIndex": `ReceiptModal_itemIndex__NjqJF`,
	"itemNameText": `ReceiptModal_itemNameText__r3wZ7`,
	"itemRow": `ReceiptModal_itemRow__iLSoi`,
	"itemRowMuted": `ReceiptModal_itemRowMuted__VgrD5`,
	"itemLeft": `ReceiptModal_itemLeft__E7fkX`,
	"itemRight": `ReceiptModal_itemRight__XHKvW`,
	"totals": `ReceiptModal_totals__N3dX0`,
	"totalLineMain": `ReceiptModal_totalLineMain__DJOpb`,
	"totalLine": `ReceiptModal_totalLine__Dsi8l`,
	"totalLabel2": `ReceiptModal_totalLabel2__zt98y`,
	"totalValue2": `ReceiptModal_totalValue2__XwhBQ`,
	"qrWrap": `ReceiptModal_qrWrap__DJB25`,
	"address": `ReceiptModal_address__PV1cm`,
	"actionBar": `ReceiptModal_actionBar__jZZj2`,
	"actionBtn": `ReceiptModal_actionBtn__CSglD`,
	"inputContainer": `ReceiptModal_inputContainer__U-oHr`
};
export default ___CSS_LOADER_EXPORT___;
